import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useNavigate } from "react-router-dom";
import {
  axiosInstancePromotion,
  CustomResponseFormat,
  setBearerTokenPromotion,
} from "api/instancePromotion";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import mixpanel from "mixpanel-browser";
import { PATH } from "../routes/paths";
import useMixpanelProfileMkt from "./useMixpanelProfileMkt";
import useMixpanelMKT from "./useMixpanelMKT";
import useGtagConversion from "./useGtagConversion";

export default function useLoginPromotion({
  url,
  idToken,
  type,
  email,
}: {
  url: string;
  idToken: string;
  type: "google" | "apple";
  email?: string;
}) {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const setUser = useSetRecoilState(userSimpleAtom);
  const setPromotionPeople = useMixpanelProfileMkt("v4");

  const trackGtagEvent = useGtagConversion();

  const trackPromotion = useMixpanelMKT({
    eventName: "가입",
    version: "v4",
  });

  const login = async () => {
    if (isLoading) return;

    setIsLoading(true);
    setError(undefined);
    try {
      const response = await axiosInstancePromotion.post<CustomResponseFormat>(
        url,
        {
          idToken: idToken,
          type: type,
          ...(email && { email: email }),
        }
      );

      if (response.code === 0) {
        const result = response.result;
        setBearerTokenPromotion(result.accessToken);
        setUser(result);

        // Track CompleteRegistration event with userId and email
        trackCapiStandardEvent("CompleteRegistration", {
          externalId: result.userId,
          email: result.email,
        });

        trackGtagEvent("CompleteRegistration", "v4");

        // Mixpanel identify with trackId
        const promotionInstance = (mixpanel as any).promotion;
        if (promotionInstance && result.trackId) {
          promotionInstance.identify(result.trackId);

          trackPromotion();

          setPromotionPeople({
            $email: result.email,
            user_id: result.userId,
          });
        }

        // nickname이 있으면 결제 페이지로, 없으면 닉네임 입력 페이지로
        if (result.nickname) {
          navigate(PATH.promotionPayment, { replace: true });
        } else {
          navigate(PATH.promotionNicknameSubmit, { replace: true });
        }
      } else {
        setError(`로그인에 실패했습니다. 다시 시도해주세요.: ${response.code}`);
      }
    } catch (error) {
      console.error("Login failed:", error);
      if (!error) {
        setError(`로그인에 실패했습니다. 다시 시도해주세요. ${error}`);
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading, error };
}
